module.exports = new __parcel__URL__("Hammer.aac09d82.jpg").toString();